import { Injectable } from '@angular/core'
import { UrlTree } from '@angular/router'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { AuctionStatusEnum } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.models'
import { GbAuctionHomeUrlService } from 'libs/gb-front/auction/util/src/lib/gb-auction-home-url-service/gb-auction-home-url.service'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { Observable, combineLatest, of } from 'rxjs'
import { switchMap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class GbCheckoutGuard {
  homeUrTree$ = this.gbAuctionHomeUrlService.homeUrlTree$

  constructor(
    private authFacade: AuthFacade,
    private auctionFacade: AuctionFacade,
    private gbAuctionHomeUrlService: GbAuctionHomeUrlService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([this.authFacade.isVolunteer$, this.auctionFacade.auctionStatus$]).pipe(
      switchMap(([isVolunteer, status]) => {
        // Volunteers can always access checkout
        if (isVolunteer) {
          return of(true)
        }
        // If auction is not stopped go to the homepage else continue to checkout where
        // the user will be prompted to log in
        if (status !== AuctionStatusEnum.Stopped) {
          return this.homeUrTree$
        } else {
          return of(true)
        }
      }),
    )
  }
}
